<template>
  <v-list-item>
    <v-list-item-avatar>
      <v-icon>mdi-account-group</v-icon>
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title>{{ group.name }}</v-list-item-title>
    </v-list-item-content>

    <v-list-item-action class="mr-4">
      <v-tooltip bottom dark>
        <template v-slot:activator="{ on }">
          <v-btn rounded color="primary" dark :loading="excelLoading" v-on="on" @click="generateReport">
            <v-icon>mdi-microsoft-excel</v-icon>
          </v-btn>
        </template>
        <span>Generuj raport</span>
      </v-tooltip>
    </v-list-item-action>

    <v-list-item-action class="mr-4">
      <SendGroupEmail :group="group" />
    </v-list-item-action>

    <v-list-item-action class="mr-4">
      <v-tooltip bottom dark>
        <template v-slot:activator="{ on }">
          <v-btn rounded :to="`/manage/groups/${group.id}/courses`" color="primary" dark v-on="on">
            <v-icon>mdi-bookshelf</v-icon>
          </v-btn>
        </template>
        <span>Edytuj szkolenia</span>
      </v-tooltip>
    </v-list-item-action>

    <v-list-item-action class="mr-4">
      <v-tooltip bottom dark>
        <template v-slot:activator="{ on }">
          <v-btn rounded :to="`/manage/groups/${group.id}/users`" color="primary" dark v-on="on">
            <v-icon>mdi-account-group</v-icon>
          </v-btn>
        </template>
        <span>Edytuj użytkowników</span>
      </v-tooltip>
    </v-list-item-action>

    <v-list-item-action>
      <UpdateGroupModal :group="group" />
    </v-list-item-action>

    <v-list-item-action>
      <DeleteGroupModal :group-id="group.id" />
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import UpdateGroupModal from '@/components/manage/groups/manage-group/UpdateGroupModal.vue';
import ReportApi from '@/api/reportApi';
import { createNamespacedHelpers } from 'vuex';
import SendGroupEmail from '@/components/manage/groups/manage-group/SendGroupEmail.vue';
import DeleteGroupModal from '@/components/manage/groups/manage-group/DeleteGroupModal.vue';

const { mapState: mapAccountState } = createNamespacedHelpers('account');

export default {
  components: {
    UpdateGroupModal,
    SendGroupEmail,
    DeleteGroupModal
  },
  props: {
    group: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      excelLoading: false
    };
  },
  computed: mapAccountState(['token']),
  methods: {
    async generateReport() {
      this.excelLoading = true;
      try {
        const api = new ReportApi(this.token);
        const response = await api.getCourseResultReport({
          groupIds: [this.group.id]
        });
        api.downloadFile(response, 'raport.xlsx');
      } catch (e) {
        console.error(e);
        // TODO: handle
      } finally {
        this.excelLoading = false;
      }
    }
  }
};
</script>
